<template lang="html">
  <button
    ref="btn"
    :tabindex="tabindex"
    v-bind="$attrs"
    :class="[`ms-button-${color}`,`ms-button-${type}`,`ms-button-${icon}`,{
      'isActive':isActive,
      'includeIcon':icon,
      'includeIconOnly':icon && !$slots.default,
      'ms-radius':radius
    }, size, classCustom]"
    :style="[styles,{
      'width': styleWidth,
      'height': !isNaN(height) ? height + 'px !important' : height + ' !important',
      'background': backgroundBtn,
      'color': colorBtn,
      'border-color': borderBtn,
      'border': typeBorderBtn,
      'margin': margin,
      'border-radius': borderRadius,
      'padding': stylePadding,
      'min-width': !isNaN(minWidth) ? minWidth + 'px !important' : minWidth + ' !important',
    }]"
    
    :type="button"
    class="ms-component ms-button"
    name="button"
    :disabled="disabled || loading"
    v-on="listeners"
    @keydown.enter="clickButton"
  >
    <span
      v-if="!is('line')&&!is('gradient')&&!is('relief')"
      ref="backgroundx"
      :style="stylesBackGround"

      class="ms-button-backgroundx ms-button--background"
    />

    <ms-icon
      v-if="icon"
      :style="{
        'order':iconAfter ? 2 : 0,
        ['margin-' + isRTL('left')]: $slots.default && !iconAfter ? '4px' : '0px',
        ['margin-' + isRTL('right')]: $slots.default && iconAfter ? '4px' : '0px',
      }"
      :icon="icon"
      :size="sizeIcon"
      :color="colorIcon"
      class="ms-button--icon"
      :class="customClassIcon"
    />

    <span
      v-if="$slots.default"
      :style="{'color':textColor}"
      class="ms-button-text ms-button--text"
      :class="{'text-normal': textNormal}"
    >
      <slot />
    </span>
    <span
      ref="linex"
      :style="styleLine"
      class="ms-button-linex"
    />
    <request-loading-indicator
      v-show="loading"
      :show-overlay="true"
      :height="24"
      :width="24"
      :color-rotator="loadingColor"
    />
  </button>
</template>

<script>
import _color from "../color";
import msIcon from "../../controls/ms-icon/MsIcon.vue"
//import eventBusGlobal from "@/bus/eventBusGlobal.js";

export default {
  name: "MsButton",
  components: {
    msIcon
  },
  inheritAttrs: false,
  props: {
    // màu của vòng loading mong muốn
    loadingColor: {
      type: String,
      default: 'mixColor',
      validator(value) {
        // The value must match one of these strings
        return ['Green', 'Red', 'Black','mixColor','Blue'].includes(value)
      }
    },

    // kiểu text font-weight
    textNormal:{
      type: Boolean,
      default: false
    },
    tabindex: {
      type: Number,
      default: 1
    },
    type: {
      default: "filled",
      type: String
    },
    color: {
      default: "default",
      type: String
    },
    textColor: {
      default: null,
      type: String
    },
    lineOrigin: {
      default: "center",
      type: String
    },
    linePosition: {
      default: "bottom",
      type: String
    },
    gradientDirection: {
      default: "30deg",
      type: String
    },
    gradientColorSecondary: {
      default: "primary",
      type: String
    },
    size: {
      type: String,
      default: null
    },
    classCustom:{
      type: String,
      default: null
    },
    icon: {
      type: [Object, String],
      default: null
    },
    iconClass: {
      type: [Object, String],
      default: null
    },
    sizeIcon: {
      default: "16px",
      type: String
    },
    iconPack: {
      type: String,
      default: "feature"
    },
    iconAfter: {
      default: false,
      type: Boolean
    },
    radius: {
      default: false,
      type: Boolean
    },
    to: {
      default: '',
      type: [String , Object]
    },
    href: {
      default: "",
      type: [String , Object]
    },
    target: {
      default: false,
      type: [Boolean, String]
    },
    button: {
      default: "button",
      type: String
    },
    colorIcon: {
      default: "white",
      type: String
    },
    disabled: {
      default: false,
      type: Boolean
    },
    height: {
      default: 36,
      type: [String, Number]
    },
    width: {
      default: "auto",
      type: [String, Number]
    },
    minWidth: {
      default: "0",
      type: [String, Number]
    },
    backgroundBtn: {
      type: String,
      default: null
    },
    colorBtn: {
      type: String,
      default: null
    },
    borderBtn: {
      type: String,
      default: null
    },
    typeBorderBtn: {
      type: String,
      default: null
    },
    margin: {
      type: String,
      default: ""
    },
    borderRadius: {
      type: String,
      default: "4px"
    },
    loading: {
      type: Boolean,
      default: false
    },
    eventStop: {
      type: Boolean,
      default: true
    },
    customClassIcon: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    isActive: false,
    hoverx: false,
    leftBackgorund: 20,
    topBackgorund: 20,
    radio: 0,
    time: 0.3,
    timeOpacity: 0.3,
    opacity: 1
  }),
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        click: event => this.clickButton(event),
        blur: event => this.blurButton(event),
        mouseover: event => this.mouseoverx(event),
        mouseout: event => this.mouseoutx(event)
      };
    },
    styles() {
      if (this.is("filled")) {
        return {
          color: _color.getColor(this.textColor, 1),
          background: _color.getColor(this.color, 1)
          // boxShadow: this.hoverx
          //   ? `0px 8px 25px -8px ${_color.getColor(this.color, 1)}`
          //   : null
        };
      } else if (this.is("border") || this.is("flat")) {
        return {
          border: `${this.is("flat") ? 0 : 1}px solid ${_color.getColor(
            this.color,
            1
          )}`,
          background: this.hoverx
            ? _color.getColor(this.color, 0.1)
            : "transparent",
          color:
            _color.getColor(this.textColor, 1) || _color.getColor(this.color, 1)
        };
      } else if (this.is("line")) {
        return {
          color:
            _color.getColor(this.textColor, 1) ||
            _color.getColor(this.color, 1),
          borderBottomWidth: this.linePosition == "bottom" ? `2px` : null,
          borderColor: `${_color.getColor(this.color, 0.2)}`,
          borderTopWidth: this.linePosition == "top" ? `2px` : null
        };
      } else if (this.is("gradient")) {
        let backgroundx = `linear-gradient(${
          this.gradientDirection
        }, ${_color.getColor(this.color)} 0%, ${_color.getColor(
          this.gradientColorSecondary,
          1
        )} 100%)`;
        return {
          background: backgroundx
        };
      } else if (this.is("relief")) {
        let color = _color.getColor(this.color, 1);
        return {
          background: _color.getColor(this.color, 1),
          boxShadow: `0 3px 0 0 ${_color.darken(color, -0.4)}`
        };
      } else{
        return false
      }
    },
    stylesBackGround() {
      let styles = {
        background:
          this.is("flat") || this.is("border")
            ? _color.getColor(this.color, 1, false)
            : null,
        opacity: this.opacity,
        left: `${this.leftBackgorund}px`,
        top: `${this.topBackgorund}px`,
        width: `${this.radio}px`,
        height: `${this.radio}px`,
        transition: `width ${this.time}s ease, height ${this.time}s ease, opacity ${this.timeOpacity}s ease`
      };

      return styles;
    },
    styleLine() {
      let lineOrigin = "50%";
      if (this.lineOrigin == "left") {
        lineOrigin = "0%";
      } else if (this.lineOrigin == "right") {
        lineOrigin = "auto";
      }

      let styles = {
        top: this.linePosition == "top" ? "-2px" : "auto",
        bottom: this.linePosition == "bottom" ? "-2px" : "auto",
        background: _color.getColor(this.color, 1),
        left: lineOrigin,
        right: lineOrigin == "auto" ? "0px" : null,
        transform: lineOrigin == "50%" ? "translate(-50%)" : null
      };

      return styles;
    },
    stylePadding() {
      var res = "0 16px";
      if (!this.$slots.default && this.icon) {
        res = "6px 5px";
      } else if (this.$slots.default && this.icon && !this.iconAfter) {
        res = "0 16px 0 12px";
      }
      else if (this.$slots.default && this.icon && this.iconAfter) {
        res = "0 8px 0 12px";
      }
      return res;
    },
    styleWidth() {
      var res = !isNaN(this.width)
        ? this.width + "px !important"
        : this.width + " !important";
      if (!this.$slots.default && this.icon) {
        res = "36px !important";
      }
      return res;
    }
  },
  methods: {
    isRTL(value) {
      if (this.$ms && this.$ms.rtl) {
        return value;
      } else {
        if (value === "right") {
          return "left";
        }
        if (value === "left") {
          return "right";
        }
      }
    },
    routerPush() {
      this.$router.push(this.to).catch(err => {
        this.$emit("routeErr", err);
      });
    },
    is(which) {
      let type = this.type;
      return type == which;
    },
    mouseoverx(event) {
      this.$emit("mouseover", event);
      this.hoverx = true;
    },
    mouseoutx(event) {
      this.$emit("mouseout", event);
      this.hoverx = false;
    },
    blurButton(event) {
      this.$emit("blur", event);
      if (this.type == "border" || this.type == "flat") {
        this.opacity = 0;
        setTimeout(() => {
          this.radio = 0;
        }, 150);
        this.isActive = false;
      }
    },
    clickButton(event) {
      this.$refs.btn.blur();
      this.eventStop && event.stopPropagation();
      // xử lý lỗi ẩn dropdown khi click button
      this.$bus.$emit("clickBtn", event);
      this.$emit("click", event);
      if (this.isActive) {
        return;
      }
      if (this.to) {
        this.routerPush();
      }
      if (this.href) {
        if (typeof this.href == "string") {
          this.target
            ? window.open(this.href)
            : (window.location.href = this.href);
        } else {
          this.target
            ? window.open(this.href.url)
            : (window.location.href = this.href.url);
        }
      }
      this.isActive = true;
      let btn = this.$refs.btn;
      let xEvent = event.offsetX;
      let yEvent = event.offsetY;
      let radio = btn.clientWidth * 3;
      this.time =
        btn.clientWidth /
        (btn.clientWidth + (this.is("border") || this.is("flat") ? 70 : 20));
      if (this.is("filled")) {
        this.timeOpacity = this.time;
      }

      if (event.srcElement ? event.srcElement != btn : false) {
        xEvent += event.target.offsetLeft;
        yEvent += event.target.offsetTop;
      }
      this.leftBackgorund = xEvent;
      this.topBackgorund = yEvent;
      this.radio = radio;
      if (this.is("filled")) {
        this.opacity = 0;
      } else {
        this.opacity = 1;
      }

      if (this.is("filled")) {
        setTimeout(() => {
          this.time = this.timeOpacity = this.radio = 0;
          this.opacity = 1;
          this.isActive = false;
        }, this.time * 1100);
      } else {
        setTimeout(() => {
          this.timeOpacity = 0.15;
        }, this.time * 1100);
      }
    }
  }
};
</script>

<style lang="scss" scoped>

@import "@/assets/scss/controls/msButton.scss";

</style>
<style lang="scss">
// Filter Button, Export Button
.ms-button-mi-filter.active,
.ms-button-mi-export.active,
.ms-button-mi-threedot.active{
  background: var(--primary-bg) !important;
  border: 1px solid var(--primary) !important;
  i {
    background-color: var(--primary) !important;
  }
}

//  Export Button trong dropdown
.ms-con-dropdown:hover {
    .ms-button-mi-export,
    .ms-button-mi-threedot {
      color: var(--primary) !important;
      background: var(--primary-bg) !important;
      border: 1px solid var(--primary) !important;
      i {
        background-color: var(--primary) !important;
      }
    }
  }




.ms-button.ms-button-filled {
  &.ms-button-secondary:hover,
  &.ms-button-secondary:focus,
  &.ms-button-secondary:active {
    i {
      background-color: var(--primary) !important;
    }
  }
}

.ms-button.ms-button-link {
  &.ms-button-primary:hover,
  &.ms-button-primary:focus,
  &.ms-button-primary:active {
    // i {
    //   background-color: var(--primary) !important;
    // }
  }
}
</style>
